import angular from 'angular';
import AdjustmentModalComponent from './adjustment.modal.component';
export default angular.module('invision.customercare.adjustmentModal', []).component('adjustmentModal', AdjustmentModalComponent).name;